export interface PromptChainResponse {
  id: string;
  name: string;
  categories: string[];
  prompts: PromptWithContextBackend[];
  is_active: boolean;
  last_edited: string;
  last_used: string;
  usage: number;
}

export interface PromptChain {
  type: 'chain';
  id: string;
  name: string;
  categories: string[];
  prompts: PromptWithContext[];
  isActive: boolean;
  lastEdited?: string;
  lastUsed?: string;
  usage?: number;
}

export interface PromptWithContext {
  promptId: string;
  contextType: ChainContext;
}

export interface PromptWithContextBackend {
  prompt_id: string;
  context_type: ChainContext;
}

export enum ChainContext {
  previousOutput = 'previous-output',
  previousOutputAndOriginal = 'previous-output-and-input',
  allPreviousOutputsAndOriginal = 'all-previous-outputs-and-input',
}

export interface IntermediateOutput {
  promptId: string;
  outputText: string;
}
